import React, { useState, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import deDE from 'antd/lib/locale/de_DE';
import reportWebVitals from './reportWebVitals';
import AuthProvider from "./containers/auth/AuthProvider";
import App from './containers/app';
import moment from "moment";
import 'moment/locale/de';
import AppProvider from "./containers/app/AppProvider";
import { TinyColor } from '@ctrl/tinycolor';

moment.locale('de');

const Root = () => {
    const envPrimaryColor = window.ENV.COLOR_PRIMARY;

    // Dynamische Farbe nur, wenn keine ENV-Farbe gesetzt ist
    const [primaryColor, setPrimaryColor] = useState(envPrimaryColor ?? '#000');

    // DARK THEME?
    const isDark = window.ENV.DARK_THEME === 'true';

    const themeConfig = useMemo(() => {
        const token = {
            fontSize: 16,
            colorPrimary: envPrimaryColor ?? primaryColor,
        };

        if (isDark) {
            token.colorBgLayout = '#2e3440';
            token.colorBgContainer = '#282D37';
            token.colorBgBase = '#282D37';
        } else {
            token.colorBgLayout = '#FFFFFF';
            token.colorBgContainer = '#FFFFFF';
            token.colorBgBase = '#FFFFFF';
        }

        // Zusätzliche Farben aus ENV übernehmen
        if (window.ENV?.THEME_COLORS) {
            Object.assign(token, JSON.parse(window.ENV.THEME_COLORS));
        }

        const headerBg = window.ENV.HEADER_BG ?? (isDark ? '#282D37' : '#f0f2f5');

        token.colorLink = token.colorPrimary;
        token.colorLinkHover = new TinyColor(token.colorLink).darken(10).toHexString();
        token.colorLinkActive = new TinyColor(token.colorLink).darken(20).toHexString();

        return {
            hashed: false,
            cssVar: true,
            algorithm: isDark ? theme.darkAlgorithm : undefined,
            token,
            components: {
                Layout: {
                    headerBg,
                },
            },
        };
    }, [primaryColor]);

    return (
        <ConfigProvider locale={deDE} theme={themeConfig}>
            <AppProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route
                                path="*"
                                element={
                                    <App
                                        // Nur setzen, wenn ENV nicht definiert ist
                                        setPrimaryColor={envPrimaryColor ? undefined : setPrimaryColor}
                                    />
                                }
                            />
                        </Routes>
                    </BrowserRouter>
                </AuthProvider>
            </AppProvider>
        </ConfigProvider>
    );
};

ReactDOM.render(<Root />, document.getElementById('root'));
reportWebVitals();
